import styled from 'styled-components';
import { Box, Flex } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import { Section, SectionTitle, SectionParagraph } from '@/components/shared/Content';
import devicesImg from '@/static/assets/notion/notion-devices.png';
import checkImg from '@/static/assets/notion/check.svg';

const SubtitleContainer = styled(Box)`
  width: 100%;
  max-width: 990px;

  ${MEDIA_QUERIES.upToDesktop`
        margin-top: 0;
        padding: 15px 77px 0 77px;
    `}
`;

const Subtitle = styled(SectionParagraph)`
  ${MEDIA_QUERIES.tabletAndDesktop`
         white-space: pre;
    `}
  ${MEDIA_QUERIES.upToDesktop`
        font-size: 1.6rem;
    `}
`;

const NotionContainer = styled(Box)`
  position: relative;

  ${MEDIA_QUERIES.desktop`
        width: 1013px;
        height: 349px;
        margin-top: 168px;
        margin-left: auto;
        margin-right: auto;
    `}

  ${MEDIA_QUERIES.upToDesktop`
        height: 713px;
        margin-top: 40px;
        margin-bottom: 40px;
    `}
    ${MEDIA_QUERIES.mobile`
        height: auto;
        margin-top: 40px;
        margin-bottom: 40px;
    `}
`;

const DevicesImg = styled.img`
  position: absolute;
  height: 500px;
  width: 545px;
  top: -101px;
  left: 219.78px;

  ${MEDIA_QUERIES.upToDesktop`
        position: relative;
        height: 250px;
        width: 259px;
        top: auto;
        left: auto;
    `}
`;

const CheckImg = styled.img.attrs({
  src: checkImg.src,
})`
  ${MEDIA_QUERIES.desktop`
        display: none;
    `}

  ${MEDIA_QUERIES.upToDesktop`
        position: relative;
        height: 31px;
        width: 31px;
        top: auto;
        margin-bottom: 20px;
    `}
`;

const ExplanationContainer = styled(Box)`
  position: absolute;

  ${MEDIA_QUERIES.upToDesktop`
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 100%;
        position: relative;
        top: auto;
        left: auto;
        right: auto;
    `}
`;

const SimpleExplanationContainer = styled(ExplanationContainer)`
  top: 25px;
  left: 0;
  width: 223px;

  ${MEDIA_QUERIES.upToDesktop`
        padding-top: 35px;
    `}
`;

const ProtectionExplanationContainer = styled(ExplanationContainer)`
  top: 0;
  right: 0px;
  width: 216px;

  ${MEDIA_QUERIES.upToDesktop`
        padding-top: 50px;
    `}
  ${MEDIA_QUERIES.mobile`
        padding-top: 70px;
    `}
`;

const SmartExplanationContainer = styled(ExplanationContainer)`
  right: 35px;
  bottom: 0;
  width: 212px;

  ${MEDIA_QUERIES.upToDesktop`
        padding-top: 50px;
        right: 0;
    `}
  ${MEDIA_QUERIES.mobile`
        right: 0;
    `}
`;

const ExplanationTitle = styled(SectionParagraph)`
  ${MEDIA_QUERIES.desktop`
        font-size: 1.4rem;
        font-weight: bold;
        text-align: left;
    `}

  ${MEDIA_QUERIES.upToDesktop`
        font-size: 1.2rem;
        font-weight: bold;
    `}
`;

const ExplanationParagraph = styled(SectionParagraph)`
  ${MEDIA_QUERIES.desktop`
        font-size: 1.6rem;
        text-align: left;
        white-space: normal;
    `}

  ${MEDIA_QUERIES.upToDesktop`
        font-size: 1.4rem;
        line-height: 19px;
    `}
`;
export interface WhatIsNotionProps {
  title: string;
  subtitle: string;
  explanation: {
    simple: {
      title: string;
      paragraph: string;
    };
    protection: {
      title: string;
      paragraph: string;
    };
    smart: {
      title: string;
      paragraph: string;
    };
  };
}

export const WhatIsNotion = ({ title, subtitle, explanation }: WhatIsNotionProps) => {
  return (
    <Section pt={[0, 60]} pb={[40, 60, 140]}>
      <SectionTitle>{title}</SectionTitle>
      <SubtitleContainer mt={[25, 19]} px={20}>
        <Subtitle>{subtitle}</Subtitle>
      </SubtitleContainer>
      <NotionContainer>
        <Flex
          mt={[0, 20]}
          pt={[0, 0, 85]}
          pb={[0, 55]}
          flexWrap="wrap"
          justifyContent="center"
          alignContent="space-between"
        >
          <DevicesImg src={devicesImg.src} />
          <SimpleExplanationContainer>
            <CheckImg />
            <ExplanationTitle>{explanation.simple.title}</ExplanationTitle>
            <ExplanationParagraph>{explanation.simple.paragraph}</ExplanationParagraph>
          </SimpleExplanationContainer>
          <ProtectionExplanationContainer>
            <CheckImg />
            <ExplanationTitle>{explanation.protection.title}</ExplanationTitle>
            <ExplanationParagraph>{explanation.protection.paragraph}</ExplanationParagraph>
          </ProtectionExplanationContainer>
          <SmartExplanationContainer>
            <CheckImg />
            <ExplanationTitle>{explanation.smart.title}</ExplanationTitle>
            <ExplanationParagraph>{explanation.smart.paragraph}</ExplanationParagraph>
          </SmartExplanationContainer>
        </Flex>
      </NotionContainer>
    </Section>
  );
};
